import { IdToOriginal } from 'components/common';
import { useMemo } from 'react';
import useOriginals from './useOriginals';

const useIdToOriginal = () => {
  const { all } = useOriginals();

  const idToOriginal: IdToOriginal = useMemo(() => {
    return all.reduce((map, o) => {
      return {
        ...map,
        [o.id]: o,
      };
    }, {});
  }, [all]);

  return idToOriginal;
};

export default useIdToOriginal;
